<template>
    <div    class="">
        <h2>Device Portal</h2>

        <div    v-if="isLoading">
            <loading-block></loading-block>
        </div>
        <div    v-else>
            <!-- Serials are listed -->
            <div    v-if="Object.keys(points).length > 0"
                    class="w-full lg:w-1/3">
                <select2    v-model:value="pointSerial"
                            :close-on-select="true"
                            :options="points"
                            placeholder="Select A Point To View"
                ></select2>
            </div>
            <!-- No Serials are found -->
            <div    v-else>
                <span>No Device Information Found</span>
            </div>
        </div>

        <div    v-if="selectedPoint !== null">
            <div    class="mt-2 w-full flex flex-col items-start">
                <span   class="text-gray-900">{{ selectedPoint.name }}</span>
                <span   class="text-gray-600">{{ selectedPoint.serial }}</span>
            </div>

            <!-- Extract into a component for full width tabs -->
            <div class="mb-4 border-b border-gray-200">
                <nav class="-mb-px flex" aria-label="Tabs">
                    <undecorated-link
                        class="border-transparent w-1/3 py-4 px-1 text-center border-b-2 font-medium text-sm"
                        :class="[selected === 'device-profile' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300']"
                        @click="updateTab('device-profile')"
                    >
                        Device Profile
                    </undecorated-link>
                    <!-- Current: "", Default: "" -->
                    <undecorated-link
                        class="border-transparent w-1/3 py-4 px-1 text-center border-b-2 font-medium text-sm"
                        :class="[selected === 'device-file' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300']"
                        @click="updateTab('device-file')"
                    >
                        Device Files
                    </undecorated-link>
                    <undecorated-link
                        class="border-transparent w-1/3 flex justify-center py-4 px-1 text-center border-b-2 font-medium text-sm"
                        :class="[selected === 'device-profile-changed' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300']"
                        @click="updateTab('device-profile-changed')"
                    >
                        <div    class="flex items-center">
                            <span>Device Profile Changed</span>
                            <span   v-if="numberDifferencesInProfile !== null"
                                    class="ml-2 p-1 px-2 rounded-full"
                                    :class="[numberDifferencesInProfile > 0 ? 'bg-red-300 text-red-700' : 'bg-green-300 text-green-700']"
                            >
                                {{ numberDifferencesInProfile }}
                            </span>
                        </div>
                    </undecorated-link>
                </nav>
            </div>

            <!-- Device Profile -->
            <div    v-if="selected === 'device-profile'">
                <device-profile-show    :point-serial="pointSerial"
                ></device-profile-show>
            </div>

            <!-- Device File -->
            <div    v-else-if="selected === 'device-file'">
                <device-files-index     :point-serial="pointSerial"
                ></device-files-index>
            </div>

            <!-- Profile Changed -->
            <div    v-else-if="selected === 'device-profile-changed'">
                <profile-changed        :point-serial="pointSerial"
                ></profile-changed>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";

import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link";
import Select2 from "@/components/elements/select2";
import DeviceProfileShow from "@/components/DevicePortal/DeviceProfileShow";
import DeviceFilesIndex from "@/components/DevicePortal/DeviceFilesIndex";
import ProfileChanged from "@/components/DevicePortal/ProfileChanged";
import Loading from "@/components/elements/loading";
import LoadingBlock from "@/components/elements/LoadingBlock";

export default {
    name: "DevicePortalIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin, UrlParamsMixin],
    components: {LoadingBlock, Loading, ProfileChanged, DeviceFilesIndex, DeviceProfileShow, UndecoratedLink, Select2},
    props: {
        
    },
    data() {
        return {
            // List of point names by serial
            points: {},
            pointSerial: '',
            numberDifferencesInProfile: null,
            isLoading: false,

            pointUpdatedAt: null,
            selectedPoint: null,

            selected: 'device-profile',
        }
    },
    created() {
        this.getPoints()
    },
    mounted() {
    },
    methods: {
        getPoints() {
            this.isLoading = true
            axios.get(this.company.buildCompanyApiInternalRoute('device-portal/')).then(response => {
                let data = response.data
                this.points = data
                this.pointSerial = ''

                if (this.urlParamsHas('serial')) {
                    let serial = this.urlParamsGet('serial')
                    if (_.has(this.points, serial)) {
                        this.pointSerial = serial
                    }
                }
            }).catch(error => {

            }).then(() => {
                this.isLoading = false
            })
        },
        updateExtraInfo() {
            this.isLoading = true
            axios.get(this.company.buildCompanyApiInternalRoute(`device-portal/${this.pointSerial}`), {

            }).then(response => {
                let data = response.data
                this.numberDifferencesInProfile = data.data.diffInTemplateCount
            }).then(() => {
                this.isLoading = false
            })
        },
        updateTab(tab) {
            this.selected = tab
        },
    },
    computed: {
        
    },
    watch: {
        pointSerial() {
            if (this.pointSerial === '' || _.isNil(this.pointSerial)) {
                this.selectedPoint = null
                this.urlParamsRemove('serial')
                return
            }

            this.selectedPoint = {
                name: this.points[this.pointSerial],
                serial: this.pointSerial,
            }
            this.numberDifferencesInProfile = null
            this.updateExtraInfo()

            // Update URL parameter to persist selection across refreshes
            this.urlParamsStore('serial', this.pointSerial)
        },
    },
}

</script>

<style scoped>

</style>